import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue from 'vue'

Vue.use(VueAxios, axios)

// take the baseurl fron env variable
Vue.axios.defaults.baseURL = process.env.VUE_APP_URL

export function get(uri, data) {
  return Vue.axios.get(uri, data)
}

export function post(uri, data) {
  return Vue.axios.post(uri, data)
}
